import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Box from './Box';
import { POSITION } from './constants';
import sx from './sx';
import theme from './theme';
var Position = styled(Box).withConfig({
  displayName: "Position",
  componentId: "fla1y3-0"
})(["", ";", ";"], POSITION, sx);
Position.defaultProps = {
  theme: theme
};
Position.propTypes = _objectSpread(_objectSpread(_objectSpread({}, Box.propTypes), POSITION.propTypes), {}, {
  theme: PropTypes.object
}, sx.propTypes);
export default Position; // Absolute

export function Absolute(props) {
  return /*#__PURE__*/React.createElement(Position, _extends({}, props, {
    position: "absolute"
  }));
}
Absolute.displayName = "Absolute";
Absolute.defaultProps = Position.defaultProps;
// Fixed

export function Fixed(props) {
  return /*#__PURE__*/React.createElement(Position, _extends({}, props, {
    position: "fixed"
  }));
}
Fixed.displayName = "Fixed";
Fixed.defaultProps = Position.defaultProps;
// Relative

export function Relative(props) {
  return /*#__PURE__*/React.createElement(Position, _extends({}, props, {
    position: "relative"
  }));
}
Relative.displayName = "Relative";
Relative.defaultProps = Position.defaultProps;
// Sticky

export function Sticky(props) {
  return /*#__PURE__*/React.createElement(Position, _extends({}, props, {
    position: "sticky"
  }));
}
Sticky.displayName = "Sticky";
Sticky.defaultProps = _objectSpread(_objectSpread({}, Position.defaultProps), {}, {
  top: 0,
  zIndex: 1
});